import { render, staticRenderFns } from "./food-select.vue?vue&type=template&id=b089a3c2&scoped=true&"
import script from "./food-select.vue?vue&type=script&lang=js&"
export * from "./food-select.vue?vue&type=script&lang=js&"
import style0 from "./food-select.vue?vue&type=style&index=0&lang=css&"
import style1 from "./food-select.vue?vue&type=style&index=1&id=b089a3c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b089a3c2",
  null
  
)

export default component.exports